import React, { useEffect, useState } from "react";

// Material UI
import Zoom from "@mui/material/Zoom";
import Tooltip from '@mui/material/Tooltip';
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import ReceiptIcon from '@mui/icons-material/Receipt';
import DialogContent from "@mui/material/DialogActions";
import { Grid } from "@mui/material";

// Components
import Modal from "../../../../components/modal/index";
import { DataGrid } from "@arredo/reactjs-ui";
// Hooks
import useAuthorize from '../../../../hooks/user/useAuthorize';

// Service
import CashRegisterService from "../../../../services/cashRegisterService";

// Models
import { cashTypesFormat, movementTypesFormat, subTypesFormat, subTypes, columns } from "../../../../models/CashRegisterMovementEntity";
import { Permissions } from '../../../../models/Roles';

//Other
import { utils } from "../../../../utils/utils";

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Zoom ref={ref} {...props} />;
});

const ViewMovements = ({ open, onClose, cashType, cashRegisterId, lastClousereDate, cashTypeId }) => {
  const isAuthorized = useAuthorize();

  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState({
    values: [],
    pageNumber: 1,
    totalPage: 0,
  });

  const [pageNumber, SetPageNumber] = useState(1);

  useEffect(() => {
    const mapCashRegisterMovements = (items) => {
      return (
        items &&
        items.values?.map((i) => ({
          ...i,
          typeFormat: movementTypesFormat[i.type] || i.type,
          subTypeFormat: subTypesFormat[i.subType] || i.subType,
          cashTypeFormat: cashTypesFormat[i.cashType] || i.cashType,
          amount: utils.formatMoney(i.amount),
        }))
      );
    };

    const handleSetViewMovements = async () => {
      setLoading(true);
      const req = {
        cashRegisterId,
        cashType,
        cashTypeId,
        from: new Date(lastClousereDate).toISOString(),
        withTime: true,
        isImprest: false
      };

      await CashRegisterService.SearchMovements(10, pageNumber, req)
        .then((res) => {
          res.values = mapCashRegisterMovements(res);
          setDetails(res);
        })
        .catch((err) => console.error(err))
        .finally(() => setLoading(false));
    };

    if (cashType) handleSetViewMovements();
  }, [cashType, cashRegisterId, pageNumber, lastClousereDate, cashTypeId]);

  const handleChangePage = (e, page) => {
    if (page < 1) page = 1;

    SetPageNumber(page);
  };

  return (
    <Modal
      dividers
      fullWidth
      fullScreen={false}
      title={`Movimientos de caja - ${cashTypesFormat[cashType]}`}
      open={open}
      onClose={onClose}
      maxWidth="lg"
      TransitionComponent={Transition}
      customButtons={() =>
        <DialogContent>
          <Button
            color="primary"
            variant="contained"
            onClick={onClose}
            startIcon={<CloseIcon />}
          >
            Cerrar
          </Button>
        </DialogContent>
      }
    >
      <Grid size={12} spacing={1}>
      <DataGrid
        columns={columns}
        rows={details?.values}
        loading={loading}
        actions={({row}) => (
          <> 
            {(row?.subType === subTypes.Sale ||
                  row?.subType === subTypes.Void ||
                  row?.subType === subTypes.Refund) &&
                  isAuthorized([Permissions.SalesView]) &&
                <Tooltip title='Ver orden' aria-label='ver'>
                  <IconButton
                    color='primary'
                    onClick={() => window.open(`/orders/detail/${row.reference}`)}
                    size="large"
                  >
                    <ReceiptIcon />
                  </IconButton>
                </Tooltip>
            }
          </>
        )}
        paginationProps={{
          count: details?.totalPage,
          page: details?.pageNumber,
          onChange: handleChangePage
        }}
      />
      </Grid>
    </Modal>
  );
};

export default ViewMovements;
